import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=55c25ba4&scoped=true&"
var script = {}
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=55c25ba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c25ba4",
  null
  
)

export default component.exports